// extracted by mini-css-extract-plugin
module.exports = {"input":"SelectInput_input__6QEx2","label":"SelectInput_label__1tqUl"};